import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import modals from "webmodals/modals";
import $session from "servicestack/session";
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import VendorPicker from 'emun.vendor/picker/vendor-picker'

// import moment from "moment";

export default class DivisionPromptController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		const {
			request = options.division,
			title
		} = options;
		console.info("options", options);
		$ctrl.request = {
			id: request.id,
			name: request.name,
			repGroup: request.repGroup,
			keyAccountGroup: request.keyAccountGroup,
			isKeyAccount: request.isKeyAccount,
			salesRepId: request.salesRepId,
			salesRep: request.salesRep
		};


		$ctrl.action = request.id ? "Update" : "Create";
		$ctrl.bus = new ServiceBus();
		$ctrl.title = title || `${$ctrl.action} Division...`;
		$ctrl.vendors = new AutoQuery({
			url: "QueryVendors.json?DivisionId=" + $ctrl.request.id,
			orderBy: "Label",
			autoLoad: true
		});
		$ctrl.territories = new AutoQuery({
			url: "QueryTerritories.json?DivisionId=" + $ctrl.request.id,
			autoLoad: true
		});
	}

	$onInit() {
		const $ctrl = this;
	}

	submit() {
		const $ctrl = this;
		$ctrl.bus
			.send(`${$ctrl.action}Division.json`, $ctrl.request)
			.then(function (response) {
				$ctrl.$emit("divisionSaved", $ctrl);
				$ctrl.$emit("refresh-divisions", response);
				$ctrl.$close(response.data);
			});
	}

	addVendor() {
		let $ctrl = this;
		$ctrl.vendorIds = [];

		return VendorPicker({
			title: "Select Vendor(s)...",
			subTitle: "",
			applyTagsButtonText: false,
			single: false,
			viewSelections: false, //vendorIds.length > 0,
			//selected: vendorIds.reduce(
			//	(m, id) => Object.assign(m, { [id]: true }),
			//	{}
			//),
			//onVendorSelected: (e) => {
			//	console.info("BL*** e.$vendor = " + JSON.stringify(e.$vendor));
			//	$ctrl.vendorIds.push(
			//	$ctrl.bus.send('AddDivisionVendor', {
			//		DivisionId: $ctrl.request.id,
			//		VendorId: e.$vendor.id
			//	});
			//}
		}).then((result) => {
			$ctrl.bus.send("AddDivisionVendors", {
				DivisionId: $ctrl.request.id,
				VendorIds: result
			}).then(function (response) {
				$ctrl.vendors.load();
			});
		});
	}
	delete() {
		const $ctrl = this;
		$ctrl.$close($ctrl.request);

		//return modals
		//  .confirm("Are you sure?", "Delete Quick Report")
		//  .result.then(function() {
		//    $ctrl.bus
		//      .send("DeleteQuickReport.json", $ctrl.request)
		//      .then(function(response) {
		//        $ctrl.$emit("quickReportDeleted", $ctrl);
		//        $ctrl.$emit("refresh-quick-report", response);
		//      });
		//  });
	}

	deleteVendor(vendor) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to remove " + vendor.label, "Remove Vendor?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeleteDivisionVendor.json", {
						DivisionId: $ctrl.request.id,
						VendorId: vendor.id
					})
					.then(function () {
						return $ctrl.vendors.load(true);
					})
					.catch(

					);
			});
	}

	dismiss() {
		const $ctrl = this;
		//$ctrl.$emit('listSaved', $ctrl);
		$ctrl.$dismiss();
	}
}
